import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PortalHomePage.css';

const PORTAL_DESTINATIONS = [
  { key: 'business', title: 'Business', tagline: 'Projects, goals, and the Delta command center.', path: '/app' },
  { key: 'development', title: 'Central Development', tagline: 'Voice-driven repo console and build tools.', path: '/coder' },
  { key: 'myai', title: 'My AI', tagline: 'Aim, plan, practice, momentum — your guided growth journey.', path: '/my-ai', featured: true },
];

const PortalHomePage = () => {
  const navigate = useNavigate();
  return (
    <div className="portal-page">
      <header className="portal-header">
        <svg width="48" height="48" viewBox="0 0 200 200" aria-hidden="true">
          <defs>
            <linearGradient id="portalGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#4A90E2" />
              <stop offset="50%" stopColor="#357ABD" />
              <stop offset="100%" stopColor="#2E5B9A" />
            </linearGradient>
          </defs>
          <polygon points="100,20 170,160 30,160" fill="url(#portalGradient)" stroke="#4A90E2" strokeWidth="2" />
        </svg>
        <h1>10x Portal</h1>
        <p className="portal-subtitle">Choose your workspace</p>
      </header>
      <main className="portal-squares">
        {PORTAL_DESTINATIONS.map(({ key, title, tagline, path, featured }) => (
          <button
            key={key}
            type="button"
            className={`portal-square portal-square--${key}${featured ? ' portal-square--featured' : ''}`}
            onClick={() => navigate(path)}
          >
            <span className="portal-square-title">{title}</span>
            <span className="portal-square-tagline">{tagline}</span>
          </button>
        ))}
      </main>
    </div>
  );
};

export default PortalHomePage;
